<template>
    <div>
        <NavBar />
 <div class="success-page">
    <div class="success-card">
    <div class="success-icon">
        ✓
      </div>

      <h1>Order Received!</h1>

      <p class="thank-you">
        Thank you for shopping with Timeless Leather.
      </p>

      <p>
        Your order has been received successfully.
        We will contact you using the details you provided
        to confirm your order and delivery.
      </p>

      <div class="order-details">

        <h3>Payment Method</h3>

        <p v-if="paymentMethod === 'card'">
          Card Payment
        </p>

        <p v-else>
          Bank Transfer
        </p>

      </div>

      <p class="note">
        Payment will be completed according to the payment method selected
        during checkout.
      </p>

      <router-link to="/leather" class="home-button">
        Continue Shopping
      </router-link>

    </div>
 </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'
export default {
  components: {
    NavBar
  },

  data() {
    return {
      paymentMethod: localStorage.getItem('paymentMethod') || 'card'
    }
  }
}
</script>


<style scoped>
.success-page {
  min-height: 100vh;
  background: #f3e5dc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.success-card {
  background: #fffaf7;
  max-width: 600px;
  width: 100%;
  padding: 50px 40px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #d9b5a4;
  box-sizing: border-box;
}

.success-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 25px;
  border-radius: 50%;
  background: #c76b4a;
  color: white;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-card h1 {
  color: #333;
  margin-bottom: 15px;
}

.success-card p {
  color: #666;
  line-height: 1.7;
}

.thank-you {
  font-size: 18px;
  color: #333 !important;
  margin-bottom: 10px;
}

.order-details {
  margin: 30px 0;
  padding: 20px;
  background: #f3e5dc;
  border-radius: 6px;
}

.order-details h3 {
  margin: 0 0 10px;
  color: #333;
}

.order-details p {
  margin: 0;
  font-weight: 600;
  color: #c76b4a;
}

.note {
  font-size: 14px;
  margin-bottom: 30px;
}

.home-button {
  display: inline-block;
  padding: 13px 25px;
  background: #c76b4a;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: 0.3s ease;
}

.home-button:hover {
  background: #333;
}
</style>
